export default "__VITE_ASSET__uFx2p96o__"